export const DISCUSS_FORUM_URL = "https://meshery.io/community#discussion-forums";